import {Modal, Stack} from "@mui/material";
import {ModalType} from "data/enums";
import {useViewController} from "data/services/locator/locator_hook.service";
import {isEqual} from "lodash";
import {observer} from "mobx-react";
import React from "react";
import {
	ModalBox,
	ModalContentCustom,
	ModalDescription,
} from "views/components/modals/modal_common.component";
import {IModalsController} from "views/controllers/modals/modals.controller";
import {Bindings} from "data/constants/bindings";

export const ModalContestShare: React.FC = observer(() => {
	const controller = useViewController<IModalsController>(Bindings.ModalsController);
	const {visibleModal} = controller;
	const isVisible = isEqual(visibleModal, ModalType.CONTEST_SHARE);

	if (!isVisible) {
		return null;
	}

	return (
		<Modal open={isVisible}>
			<ModalBox>
				<ModalContentCustom>
					<Stack direction={"column"} alignItems={"center"}>
						<ModalDescription>
							<h1>This is the Contest Share Modal</h1>
						</ModalDescription>
					</Stack>
				</ModalContentCustom>
			</ModalBox>
		</Modal>
	);
});
